import LinkedShowsList from "components/LinkedShows/LinkedShowsList";
import { LargeClickableTitle } from "components/ListTemplate/LargeClickableTitle";
import { type ListTemplateLayout } from "components/ListTemplate/types";
import { GroundTransportSidePanel } from "components/SidePanel/GroundTransport/GroundSidePanel";
import React from "react";
import { formatTime, formatWrittenDayMonthYear } from "utilities";

const GroundTransportFromTo = ({ groundTransport }: { groundTransport: server.dto.GroundTransportForList }) => {

  const startDateWritten = formatWrittenDayMonthYear(groundTransport.dateTime.startDisplay);
  const endDateWritten = formatWrittenDayMonthYear(groundTransport.dateTime.endDisplay);

  const startTimeWritten = formatTime(groundTransport.dateTime.startDisplay);
  const endTimeWritten = formatTime(groundTransport.dateTime.endDisplay);

  const arrivalDateAndTime = startDateWritten === endDateWritten
    ? endTimeWritten
    : `${endDateWritten} ${endTimeWritten}`;

  return <div className="flex-2 journey-card-grid">
    <div className="departs-from">
      <div className="info-text-regular margin-bottom-large">
        {startDateWritten}
      </div>
      <div className="subtitle-text-regular margin-bottom-small">
        {groundTransport.startGooglePlaceName}
      </div>
      <div className="text-sublabel margin-bottom-small">
        {groundTransport.startGooglePlaceAddress}
      </div>
    </div>
    <div className="departure-time nowrap info-text-regular">
      {startTimeWritten}
    </div>
    <div className="arrow">
      <i className="icon-arrow-right small" />
    </div>
    <div className="arrives-at">
      <div className="info-text-regular margin-bottom-large">
        {arrivalDateAndTime}
      </div>
      <div className="subtitle-text-regular margin-bottom-small">
        {groundTransport.endGooglePlaceName}
      </div>
      <div className="text-sublabel margin-bottom-small">
        {groundTransport.endGooglePlaceAddress}
      </div>
    </div>
  </div>;
};

export const cardLayout = (): ListTemplateLayout<server.dto.GroundTransportForList> => ({
  type: "card",
  sections: {
    renderTitle: item =>
      <GroundTransportSidePanel
        groundTransportId={item.groundTransportId}
        trigger={<LargeClickableTitle
          title={item.title}
        />}
      />,
    hideTitle: () => false,
    renderBody: item => <>
      <GroundTransportFromTo groundTransport={item} />
      <LinkedShowsList shows={item.linkedShows} />
    </>,
    renderFooter: item => <div>
      <div className="margin-bottom-small">
        <span>{item.artist.name}</span>
      </div>
      <div>
        {item.passengers.map((passenger, index) => <React.Fragment key={passenger.contactId}>
          <span className="s1_gray">{passenger.name.fullName}</span>
          {item.passengers.length - 1 !== index && <span className="s1_gray">, </span>}
        </React.Fragment>)}
      </div>
    </div>,
    hideFooter: item => !item.artist && item.passengers.length === 0
  }
});